<template>
  <button :disabled="readOnly" class="editable-button" v-bind="$attrs" :class="buttonClass" type="button">
    <slot name="editable-text"></slot>
    <q-menu
      anchor="bottom middle"
      self="top middle"
      @hide="resetValue"
      :model-value="isOpen"
      @update:model-value="$emit('update:is-open', $event)"
    >
      <q-card :class="!hideSlider ? 'with-chart' : ''">
        <q-card-section class="row justify-between items-center q-py-sm card-wrapper">
          <slot name="resource-label"></slot>
          <q-btn flat size="12px" icon="fa-regular fa-xmark" class="q-pa-xs" round v-close-popup></q-btn>
        </q-card-section>
        <q-card-section class="q-py-sm">
          <div class="row" :class="{ 'input-row': !hideSlider }">
            <div :class="{ 'col-9': !hideSlider }">
              <slot name="input"></slot>
            </div>
            <div class="col">
              <slot name="units"></slot>
            </div>
          </div>
          <div v-if="!hideSlider">
            <slot name="slider"></slot>
          </div>
        </q-card-section>
        <q-card-section class="row justify-end q-py-sm">
          <q-btn
            aid="save-quota-btn"
            flat
            color="primary"
            label="Apply"
            v-close-popup="!isInputInvalid"
            @click="updateModelValue"
          />
        </q-card-section>
      </q-card>
    </q-menu>
    <q-field v-if="shouldValidate" :rules="[validateAlert]" model-value="" style="display: none" />
    <q-tooltip
      v-if="isAlertOn && !isOpen"
      max-width="350px"
      :offset="[180, 0]"
      :class="tooltipAlertClass"
      anchor="top right"
    >
      <slot name="alert-text"></slot>
    </q-tooltip>
  </button>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  name: "quota-menu-button",
  emits: ["reset-value", "update:is-open", "update:model-value"],
  props: {
    readOnly: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isOpen: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    hideSlider: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isInputInvalid: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isAlertOn: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    buttonClass: {
      type: String as PropType<string>,
      default: "",
    },
    tooltipAlertClass: {
      type: String as PropType<string>,
      default: "",
    },
  },
  setup(_, { emit }) {
    const updateModelValue = () => {
      emit("update:model-value");
    };

    return {
      updateModelValue,
    };
  },
  computed: {
    shouldValidate(): boolean {
      return this.buttonClass === "negative-border";
    },
  },
  methods: {
    resetValue(): void {
      this.$emit("reset-value");
    },
    validateAlert(): boolean | string {
      return !this.isAlertOn || "";
    },
  },
});
</script>

<style lang="scss" scoped>
.card-wrapper {
  font-weight: 500 !important;
  font-size: 14px;
}
.with-chart {
  min-height: 400px;
  width: 400px;
}
.input-row {
  height: 110px;
}
.editable-button {
  cursor: pointer;
  width: 100px;
  height: 40px;
  border-radius: 5px;
  border: 1px solid $black-30;
  text-align: center;
  color: $black-70;
  background-color: white;
  font-weight: 500;
  transition: box-shadow 0.3s;

  &:hover {
    border: 1px solid $black-70;
  }
}
.primary-border {
  border: 2px solid $primary;
}
.amber-14-border {
  border: 2px solid $amber-14;
}
.negative-border {
  border: 2px solid $negative;
}
.quota-exceeds-alert {
  margin: 5px 0;
  font-size: 12px;
  max-width: 231px;
  top: 65px;
  position: absolute;
  line-height: 12px;
}
</style>
